var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 402,
    viewBox: "0 0 406 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 297.5L42 278L52 264L73.5 286L62 297.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285 70.5L265 51L275 37L296.5 59L285 70.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M402 401L402 310.284C402 302.412 398.906 294.855 393.385 289.244L371.5 267",
    stroke: "black",
    strokeWidth: 7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 313.5L103.5 300L93.5 321L183 345L152 313.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313.5 147.5L300.135 99.6046L320.998 89.323L345 179.5L313.5 147.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107 306C107 319.807 95.8071 331 82 331C68.1929 331 57 319.807 57 306C57 292.193 68.1929 281 82 281C95.8071 281 107 292.193 107 306Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90 306.5C90 311.194 86.1944 315 81.5 315C76.8056 315 73 311.194 73 306.5C73 301.806 76.8056 298 81.5 298C86.1944 298 90 301.806 90 306.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332 81C332 94.8071 320.807 106 307 106C293.193 106 282 94.8071 282 81C282 67.1929 293.193 56 307 56C320.807 56 332 67.1929 332 81Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M316 80.5C316 85.1944 312.194 89 307.5 89C302.806 89 299 85.1944 299 80.5C299 75.8056 302.806 72 307.5 72C312.194 72 316 75.8056 316 80.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M272.15 150.6C265.878 144.328 265.878 134.159 272.15 127.886C278.422 121.614 288.591 121.614 294.863 127.886L390.535 223.558C396.807 229.83 396.807 239.999 390.535 246.271C384.262 252.543 374.093 252.543 367.821 246.271L272.15 150.6Z",
    fill: "#F39C12"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M229.678 146.128C219.915 155.891 219.915 171.72 229.678 181.483L336.753 288.559C346.516 298.322 362.345 298.322 372.108 288.559L402.237 258.431L259.806 116L229.678 146.128Z",
    fill: "#1C1C1C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M235.557 140.25L378 282.693L402.249 258.443L259.806 116L235.557 140.25Z",
    fill: "#F1C40F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M342.135 175.154L390.357 223.376C396.756 229.776 396.756 240.152 390.357 246.552L330.547 186.742L342.135 175.154Z",
    fill: "#E67E22"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M330.537 186.736L402.23 258.429L377.993 282.666L306.3 210.973L330.537 186.736Z",
    fill: "#F39C12"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.606 271.15C145.334 264.878 135.165 264.878 128.893 271.15C122.62 277.422 122.62 287.591 128.893 293.863L224.564 389.535C230.836 395.807 241.005 395.807 247.278 389.535C253.55 383.262 253.55 373.093 247.278 366.821L151.606 271.15Z",
    fill: "#F39C12"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.134 228.678C156.897 218.915 172.727 218.915 182.49 228.678L289.565 335.753C299.328 345.516 299.328 361.345 289.565 371.108L259.437 401.237L117.006 258.806L147.134 228.678Z",
    fill: "#1C1C1C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.256 234.557L283.699 377L259.449 401.249L117.006 258.806L141.256 234.557Z",
    fill: "#F1C40F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.161 341.135L224.383 389.357C230.782 395.756 241.158 395.756 247.558 389.357L187.748 329.547L176.161 341.135Z",
    fill: "#E67E22"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.743 329.537L259.436 401.23L283.673 376.993L211.98 305.3L187.743 329.537Z",
    fill: "#F39C12"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.179 65.7452C151.044 37.3069 197.489 28.6534 269.552 53.0423C287.822 49.9936 290.36 30.6852 274.627 18.9986C206.113 -9.96325 132.017 -6.91465 78.728 35.7664L40.1572 73.875C-8.05815 131.801 -10.0829 204.969 19.3493 276.105C32.0406 291.349 53.8635 286.268 52.8485 266.451C28.999 201.921 34.0706 143.996 71.6228 102.838L109.179 65.7452Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.467 36.0335C194.826 8.73133 142.851 18.4185 96.0021 50.2538L53.9754 91.7771C11.9527 137.852 6.27732 202.697 32.966 274.935C33.1483 278.495 32.6724 281.631 31.686 284.315C27.3254 283.143 22.9665 280.45 19.3493 276.105C-10.0829 204.969 -8.05815 131.801 40.1572 73.875L78.728 35.7664C132.017 -6.91464 206.113 -9.96325 274.627 18.9986C280.031 23.0129 283.28 27.9264 284.475 32.7714C282.008 34.3104 279.001 35.4438 275.467 36.0335Z",
    fill: "#1C1C1C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.f76c5bac15f2b7e00c82be3bb6cc77e4.svg";
export { ForwardRef as ReactComponent };